import $ from "jquery";
import {MAX_MOBILE_WIDTH} from "Core/screenSizes";

const isTablet = () => {
    return window.outerWidth < MAX_MOBILE_WIDTH
};

export const navSpacerHeight = () => {
    const navLine = $('.nav-line');

    if (!isTablet()) {
        return;
    }

    if (navLine.length === 0) {
        return;
    }
};
